import React from "react";

import { addUrlPrefix } from "../../utils/urlValidations";
import "./bookmark.scss";
import A from "../elements/A";
import { useAppSelector } from "../../hooks";

export interface BookmarkProps {
  widget_id?: string;
}

export default function Bookmark(props: BookmarkProps) {
  const bookmarks = useAppSelector(state => state.layouts.bookmarks);
  const bookmark = bookmarks
    ? bookmarks.find(bookmark => bookmark.widget_id === props.widget_id)
    : null;

  return (
    <div className="bookmark-container">
      {bookmark ? (
        <A
          href={addUrlPrefix(bookmark.url)}
          target="_blank"
          rel="noopener noreferrer"
          className="body-layout-font"
        >
          {bookmark.name}
        </A>
      ) : (
        <p className="body-layout-font">Bookmark is currently in edit mode</p>
      )}
    </div>
  );
}
